/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.MeevoStore {
    'use strict';

    import ModuleEnum = Meevo.Model.ModuleEnum;

    export enum SaleItemTypeEnum {
        Integrations = 30385,
        AddOns = 30384,
        PublicApp = 11045053
    }

    export interface IMeevoStoreModuleType {
        hintText?: string;
        description?: string;
        displayName: string;
        isPending?: boolean;
        salesForceId: string;
        isTurnedOnForLocation: boolean;
        bundled: boolean;
        moduleId: number;
        moduleTypeEnum: SaleItemTypeEnum;
        price: number;
        salesForceReferenceNumber?: string;
        sFOrderNumber?: string;
        hidePrice?: boolean;
        hideAgreement?: boolean;
        buttonText?: string;
        meevoStoreUrl?: string;
    }

    export interface StoreSaleItemCartItem {
        actionType: StoreActionTypeEnum,
        meevoId: number,
        salesForceId: string,
        type: SaleItemTypeEnum
    }

    export class SaleItemTypeController {
        static $inject = [
            '$scope',
            '$rootScope',
            '$state',
            '$q',
            '$translate',
            '$window',
            'meevo.AppSettings',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService',
            'meevo.components.busy.BusyService',
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            'meevo.plugins.meevoStore.MeevoStoreService',
        ];

        public isInDev: boolean = true;

        public itemList: Array<IMeevoStoreModuleType>;
        public itemType: SaleItemTypeEnum;
        public accountInfo: IStoreAccountInfo;

        constructor(
            protected $scope: angular.IScope,
            protected $rootScope: ng.IRootScopeService,
            protected $state: ng.ui.IStateService,
            protected $q: angular.IQService,
            protected $translate: angular.translate.ITranslateService,
            protected $window: angular.IWindowService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected storeService: Meevo.Plugins.MeevoStore.IMeevoStoreService,
        ) {

        }

        public getItemList (itemType, isUpdate = false) {
            this.busyService.start();

            this.storeService.getAccountInfo().then((data) => {
                this.accountInfo = data;

                if (!this.accountInfo.pendingRequests) {
                    this.accountInfo.pendingRequests = [];
                }

                this.storeService.getSaleItemList(itemType, this.accountInfo.currentEditionId).then((response: any) => {
                    this.itemList = response.data;

                    this.itemList.forEach((el) => {
                        if (el.sFOrderNumber) {
                            el.salesForceReferenceNumber = el.sFOrderNumber;
                        }
                    });

                    this.busyService.stop();

                    if (this.accountInfo.pendingRequests.length > 0 && !isUpdate) {
                        let textIsPending = this.$translate.instant('LABEL_MEEVOSTORE_IS_PENDING',
                            {
                                salesforceOrder: this.accountInfo.pendingRequests[0].salesForceReferenceNumber,
                                meevoItem: 'Meevo',
                                moduleName: this.accountInfo.pendingRequests[0].displayName
                            });
                        this.modalService.alert(textIsPending, Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate);
                    }
                });
            });
        }

        public moreInfoBtn (item: IMeevoStoreModuleType): ng.IPromise<any>  {

            // Initialize modal
            return this.showModalInfo(item).then((res) => {
                if (res.status === false) return;

                if (res.canProcess === true) {
                    let headerContentKey = 'HEADER_CONFIRM',
                        confirmText = 'TEXT_MEEVOSTORE_CONFIRM_CHANGES_ADD',
                        confirmItem = `<ul><li><strong>${item.displayName}</strong></li></ul>`;

                    if (this.itemType == SaleItemTypeEnum.Integrations || this.itemType == SaleItemTypeEnum.PublicApp) {
                        confirmText = 'TEXT_MEEVOSTORE_CONFIRM_CHANGES_INTEGRATE';
                    } else if (this.itemType == SaleItemTypeEnum.AddOns) {
                        confirmText = 'TEXT_MEEVOSTORE_CONFIRM_CHANGES_ADD';
                    }

                    this.storeService.openConfirmModal(headerContentKey, confirmText, confirmItem).then((res) => {
                        if(res.status === true) {

                            this.busyService.start();

                            // Add item to cart
                            let cartItem = {
                                meevoId: item.moduleId,
                                salesForceId: item.salesForceId,
                                actionType: StoreActionTypeEnum.Add,
                                type: this.itemType,
                            };

                            this.dataService.customMethodData(this.appSettings.API_ROOT + '/' + this.appSettings.ROUTE_NAMES.meevoStore + '/SaleItem', 'POST', cartItem).then(resp => {

                                // Sale items from Cart
                                this.dataService.customMethodData(this.appSettings.API_ROOT + '/' + this.appSettings.ROUTE_NAMES.meevoStore + '/Sale', 'POST', {}).then((response: any) => {

                                    this.busyService.stop();

                                    if (response.status == 409) {
                                        this.modalService.error(response.data.responseStatus.message, Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate);
                                        return;
                                    }

                                    // Update list after sale
                                    this.getItemList(this.itemType, true);

                                    //open in browser
                                    const modulesToOpen = [ModuleEnum.Octopi, ModuleEnum.ADPWiselyIntegration];

                                    if (modulesToOpen.indexOf(item.moduleId) >= 0) {
                                        this.$window.open(item.meevoStoreUrl, '_blank');
                                    }
                                    
                                    this.storeService.openPurchaseModal(response.data.orderNumber, response.data.url);
                                });
                            });
                        }
                    });
                }

                if (res.canRemove === true) {
                    this.removeBtn(item);
                }
            });
        }

        public removeBtn (item: IMeevoStoreModuleType): ng.IPromise<any>  {
            let confirmItem = `<ul><li><strong>${item.displayName}</strong></li></ul>`;

            let headerContentKey = 'HEADER_CONFIRM',
                confirmText = 'TEXT_MEEVOSTORE_CONFIRM_CHANGES_REMOVE';

            // Initialize modal
            return this.storeService.openConfirmModal(headerContentKey, confirmText, confirmItem).then((res) => {
                if(res.status === true) {

                    this.busyService.start();
                    let cartItem = {
                        meevoId: item.moduleId,
                        salesForceId: item.salesForceId,
                        actionType: StoreActionTypeEnum.Remove,
                        type: this.itemType,
                    };
                    // Add item to cart
                    this.dataService.customMethodData(this.appSettings.API_ROOT + '/' + this.appSettings.ROUTE_NAMES.meevoStore + '/SaleItem', 'POST', cartItem).then(resp => {

                        // Sale items from Cart
                        this.dataService.customMethodData(this.appSettings.API_ROOT + '/' + this.appSettings.ROUTE_NAMES.meevoStore + '/Sale', 'POST', {}).then(responseSale => {

                            this.busyService.stop();
                            if (responseSale.status == 409) {
                                this.modalService.error(responseSale.data.responseStatus.message, Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate);
                                return;
                            }

                            // Update list after sale
                            this.getItemList(this.itemType, true);
                        });
                    });
                }
            });
        }

        public showModalInfo (item: IMeevoStoreModuleType): ng.IPromise<any> {
            let title = '',
                pendingText = '',
                isProcess = !!item.salesForceReferenceNumber,
                canRemove = item.isTurnedOnForLocation && !item.bundled && !item.salesForceReferenceNumber && this.accountInfo.pendingRequests.length === 0,
                canProcess = !item.isTurnedOnForLocation && !item.salesForceReferenceNumber && this.accountInfo.pendingRequests.length === 0;

            if (this.itemType == SaleItemTypeEnum.Integrations || this.itemType == SaleItemTypeEnum.PublicApp) {
                title = 'LABEL_MEEVOSTORE_INTEGRATIONS';
                pendingText =  this.$translate.instant('LABEL_MEEVOSTORE_IS_PENDING',
                    {
                        salesforceOrder: item.salesForceReferenceNumber,
                        meevoItem: this.$translate.instant('LABEL_MEEVOSTORE_INTEGRATIONS'),
                        moduleName: item.displayName
                    });
            } else if (this.itemType == SaleItemTypeEnum.AddOns) {
                title = 'LABEL_BUSINESS_BOOSTERS';
                pendingText =  this.$translate.instant('LABEL_MEEVOSTORE_IS_PENDING',
                    {
                        salesforceOrder: item.salesForceReferenceNumber,
                        meevoItem: this.$translate.instant('LABEL_BUSINESS_BOOSTERS'),
                        moduleName: item.displayName
                    });
            }

            let description = this.$translate.instant(item.description,
                {
                    price: item.price,
                });

            // Initialize modal
            const options: Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/meevoStore/pages/modalInfo/modalInfo.html',
                clickOutsideToClose: false,
                bindToController: true,
                skipHide: true,
                locals: {
                    storeService: this.storeService,
                    modalTitle: title,
                    modalText: description,
                    canProcess: canProcess,
                    canRemove: canRemove,
                    pendingText: pendingText,
                    isProcess: isProcess,
                    module: item,
                },
                controller: 'meevo.plugins.meevoStore.ModalInfoController',
                controllerAs: 'vm'
            };
            return this.modalService.showCustom(options);
        }

    }
    angular.module('meevo.plugins.meevoStore')
        .controller('meevo.plugins.meevoStore.SaleItemTypeController', SaleItemTypeController);
}
